import { InstrumentCategoryEnum } from '@eih-netbroker/common';
import classes from './InstrumentCategoryLogo.module.scss';

interface InstrumentCategoryLogoProps {
  instrumentCategory: InstrumentCategoryEnum;
  className?: string;
}

export const InstrumentCategoryLogo = ({ instrumentCategory, className }: InstrumentCategoryLogoProps) => {
  const getInstrumentCategoryClass = (instrumentCategory: InstrumentCategoryEnum) => {
    switch (instrumentCategory) {
      case InstrumentCategoryEnum.Equity:
        return classes.logoBgIsEquity;
      case InstrumentCategoryEnum.Futures:
        return classes.logoBgIsFutures;
      case InstrumentCategoryEnum.Certificate:
        return classes.logoBgIsCertificate;
      case InstrumentCategoryEnum.Warrant:
        return classes.logoBgIsWarrant;
      case InstrumentCategoryEnum.ETF:
        return classes.logoBgIsETF;
      case InstrumentCategoryEnum.InvestmentFund:
        return classes.logoBgIsInvestmentFund;
      case InstrumentCategoryEnum.GovernmentBond:
        return classes.logoBgIsGovernmentBond;
      case InstrumentCategoryEnum.Bond:
        return classes.logoBgIsBond;
      case InstrumentCategoryEnum.CompensationNote:
        return classes.logoBgIsCompensationNote;
      case InstrumentCategoryEnum.Option:
        return classes.logoBgIsOption;
      case InstrumentCategoryEnum.Currency:
        return classes.logoBgIsCurrency;
      case InstrumentCategoryEnum.StructuredProduct:
        return classes.logoBgIsStructuredProduct;
      case InstrumentCategoryEnum.Index:
        return classes.logoBgIsIndex;
      case InstrumentCategoryEnum.Other:
        return classes.logoBgIsOther;
      default:
        return '';
    }
  };

  const getInstrumentCategoryText = (instrumentCategory: InstrumentCategoryEnum) => {
    return instrumentCategory;
  };

  return (
    <div className={classes.logo}>
      <span className={`${classes.logoBg} ${getInstrumentCategoryClass(instrumentCategory)} ${className ?? ''}`}>
        {getInstrumentCategoryText(instrumentCategory)}
      </span>
    </div>
  );
};
